import * as React from 'react';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import { DeliverableLook as DeliverableLookAlias } from 'types';

import './deliverable-look.scss';

applyTranslations(require('./deliverable-look.i18n.json'));

type Callback = (look: DeliverableLookAlias) => void;

type Props = {
  look: DeliverableLookAlias,
  onEdit: Callback,
  onDelete: Callback
};

const msgKey = 'deliverable_look';

const renderIcon = (
  key: 'edit' | 'delete',
  look: DeliverableLookAlias,
  icon: string,
  callback: Callback
): React.ReactNode => (
  <div className="deliverable-looks__action">
    <Tooltip
      message={__t(`${msgKey}.${key}_look`)}
      width="macro"
      trigger="hover"
    >
      <SVGDynamicIcon
        name={icon}
        width={12}
        height={12}
        clickable
        customColor="grey"
        onClick={() => callback(look)}
      />
    </Tooltip>
  </div>
);

const DeliverableLook = ({ look, onEdit, onDelete }: Props) => (
  <div className="deliverable-looks__item">
    <div
      className="deliverable-looks__name text-overflow-ellipsis"
      title={look.title}
    >
      {look.title}
    </div>
    <div className="deliverable-looks__actions">
      {
        look.isTag ? (
          <Tooltip
            showQuestionMark
            message={__t(`${msgKey}.look_tooltip`)}
          />
        ) : (
          <React.Fragment>
            {renderIcon('edit', look, 'pencil-custom-bg', onEdit)}
            {renderIcon('delete', look, 'trash-custom-fg', onDelete)}
          </React.Fragment>
        )
      }
    </div>
  </div>
);


export default DeliverableLook;
